import {
  StreamingConstraintRule,
  StreamingGlobalSettings
} from '@blisspointmedia/bpm-types/dist/OptimizationConstraints';

export const getBudgetInputError = (row: StreamingConstraintRule): string | undefined => {
  const values = [row.minValue, row.maxValue, row.minPct, row.maxPct];
  if (values.some(value => value != null && (!Number.isFinite(value) || value < 0))) {
    return 'Minimums and maximums must be finite, nonnegative numbers';
  }
  if ([row.minPct, row.maxPct].some(value => value != null && value > 1)) {
    return 'Minimum and maximum percentages must be between 0% and 100%';
  }
  return undefined;
};

export const getGlobalInputError = (row: {
  key?: keyof StreamingGlobalSettings;
  value?: number;
}): string | undefined => {
  const { value } = row;
  if (value == null || !Number.isFinite(value)) {
    return 'Value must be a finite number';
  }
  if (row.key?.includes('Pct') && (value < 0 || value > 1)) {
    return 'Percentage must be between 0% and 100%';
  }
  if (row.key === 'maxExtrapolationRatio' && value < 1) {
    return 'Invalid input: Extrapolation Ratio must be greater than or equal to 1.';
  }
  return undefined;
};
